import React from 'react';
import Button from '../ui/Button';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <div className="relative bg-brand-cream pt-12 pb-24 md:pt-20 md:pb-40 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="w-full lg:w-3/5">
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="flex flex-col items-start"
            >
              <div className="mb-8">
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/7c98abf852f963e06195176deed57bb9c81b4f53d205af5ca5b2f9af1b9cfaa840d35f6737e086b8644a3796bedcf0cc/images/aW1hZ2UvcG5n/51bb34f9956cf11fb97ebb2a9db89eac.png" 
                  alt="AI CoLab Studio" 
                  className="h-24 md:h-32 w-auto object-contain"
                />
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brand-navy leading-[1.1] mb-8 tracking-tight">
                Helping leaders lead AI with confidence <span className="text-brand-teal">without losing what makes them human.</span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-700 mb-10 max-w-2xl leading-relaxed font-medium">
                AI is already changing how your organisation works. We help leaders decide where AI belongs, where people should lead, and how to build organisational confidence that strengthens your mission.
              </p>
              <div className="flex flex-col sm:flex-row gap-5 w-full sm:w-auto">
                <Button to="/assessment" variant="primary" className="text-lg px-8 py-5 shadow-lg shadow-brand-teal/20">
                  Take the AI Leadership Health Check
                </Button>
                <Button to="/safe-ai-framework" variant="outline" className="text-lg px-8 py-5 bg-white border-2">
                  Explore the SAFE AI Framework
                </Button>
              </div>
            </motion.div>
          </div>
          
          <div className="w-full lg:w-2/5 relative">
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative z-10 rounded-[3rem] overflow-hidden shadow-2xl border-8 border-white"
            >
              <img 
                src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=1200" 
                alt="Leadership Team Collaboration" 
                className="w-full h-auto object-cover"
              />
            </motion.div>
            <div className="absolute -top-12 -left-12 w-48 h-48 bg-brand-gold/20 rounded-full blur-3xl -z-0"></div>
            <div className="absolute -bottom-12 -right-12 w-64 h-64 bg-brand-teal/20 rounded-full blur-3xl -z-0"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;